import * as SystemUtils from 'utils/system'
import DataTypes from 'constants/DataTypes'

// Whether a device can measure the parameter the alert is about.
export const systemSupportsType = (system, selectedType) => {
  const sortedData = SystemUtils.getDataSorted(system)

  if (selectedType === 'tempHigh' || selectedType === 'tempLow') {
    return sortedData.some(
      item => item.type === DataTypes.TEMPERATURE || item.type === DataTypes.RADIANT_TEMPERATURE
    )
  }
  if (selectedType === 'humHigh' || selectedType === 'humLow') {
    return sortedData.some(item => item.type === DataTypes.HUMIDITY)
  }
  return sortedData.some(item => item.type === selectedType)
}

// The device already has an alert covering every chosen parameter.
export const hasDuplicateAlarm = (systemId, typeSelected, parameterAlarmParamsBySystem) => {
  const alarmsParams = parameterAlarmParamsBySystem[systemId] || []
  return alarmsParams.some(alarmParams => typeSelected.every(param => alarmParams.includes(param)))
}

/**
 * A device the alert cannot use. The devices step disables these, and the
 * provider drops them from the selection when the parameters change, so both
 * have to ask the same question.
 *
 * A device already used by the alert being edited is always allowed. Its own
 * alert is the duplicate that would otherwise rule it out.
 */
export const isInvalidDevice = ({
  system,
  typeSelected,
  parameterAlarmParamsBySystem = {},
  existingDeviceIds = [],
  formMode = 'add'
}) => {
  const isExistingEditDevice = formMode === 'edit' && existingDeviceIds.includes(system._id)

  return (
    !systemSupportsType(system, typeSelected[0]) ||
    (!isExistingEditDevice &&
      hasDuplicateAlarm(system._id, typeSelected, parameterAlarmParamsBySystem))
  )
}
